/* Maya Hair Oil — theme interactivity
   Header, scroll reveal, mobile menu, accordions, gallery, quantity,
   Shopify AJAX cart drawer, and the motion / parallax layer. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header solidify ---------- */
  var hdr = $('#hdr');
  if (hdr) {
    var alwaysSolid = hdr.classList.contains('always-solid');
    var onScroll = function () { hdr.classList.toggle('solid', alwaysSolid || window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- mobile menu ---------- */
  var mm = $('#mmenu'), burger = $('#burger'), mclose = $('#mclose');
  if (burger && mm) burger.onclick = function () { mm.classList.add('show'); };
  if (mclose && mm) mclose.onclick = function () { mm.classList.remove('show'); };
  if (mm) $$('a', mm).forEach(function (a) { a.onclick = function () { mm.classList.remove('show'); }; });

  /* ---------- accordions (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest ? e.target.closest('.acc-head') : null;
    if (!h) return;
    var item = h.parentElement, body = h.nextElementSibling, open = item.classList.contains('open');
    item.classList.toggle('open');
    if (body) body.style.maxHeight = open ? null : body.scrollHeight + 'px';
  });

  /* ---------- product gallery ---------- */
  $$('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var main = $('#mainImg');
      if (main) main.src = t.getAttribute('data-img');
    });
  });

  /* ---------- quantity stepper ---------- */
  var qVal = $('#qVal');
  if (qVal) {
    var qMinus = $('#qMinus'), qPlus = $('#qPlus');
    if (qMinus) qMinus.onclick = function () { qVal.value = Math.max(1, (parseInt(qVal.value, 10) || 1) - 1); };
    if (qPlus) qPlus.onclick = function () { qVal.value = (parseInt(qVal.value, 10) || 1) + 1; };
    qVal.oninput = function () { qVal.value = qVal.value.replace(/[^0-9]/g, ''); };
  }

  /* ---------- variant select → price ---------- */
  var vSelect = $('[data-variant-select]');
  if (vSelect) {
    vSelect.addEventListener('change', function () {
      var opt = vSelect.options[vSelect.selectedIndex];
      var priceEl = $('[data-price]');
      if (opt && priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
    });
  }

  /* ---------- toast ---------- */
  var toast = $('#toast'), toastMsg = $('#toastMsg'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (toastMsg) toastMsg.textContent = msg || 'Added to cart';
    clearTimeout(toastTimer);
    toast.classList.add('show');
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2400);
  }

  /* ---------- cart drawer + Shopify AJAX ---------- */
  var overlay = $('#overlay'), drawer = $('#drawer');
  var drawerBody = $('#drawerBody'), drawerFoot = $('#drawerFoot');
  var cartCount = $('#cartCount'), cartTotal = $('#cartTotal');
  var moneyFormat = drawerBody ? drawerBody.getAttribute('data-money-format') : '${{amount}}';

  function openCart() { if (overlay) overlay.classList.add('show'); if (drawer) drawer.classList.add('show'); }
  function closeCart() { if (overlay) overlay.classList.remove('show'); if (drawer) drawer.classList.remove('show'); }
  var cartOpen = $('#cartOpen'), cartClose = $('#cartClose');
  if (cartOpen) cartOpen.onclick = function (e) { e.preventDefault(); openCart(); };
  if (cartClose) cartClose.onclick = closeCart;
  if (overlay) overlay.onclick = closeCart;

  var DH = '<svg class="dh-sym" viewBox="0 0 32 32" aria-label="AED" focusable="false"><g fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v22"/><path d="M12 5h4.5a11 11 0 0 1 0 22H12"/><path d="M5.5 13h13.5"/><path d="M5.5 20h13.5"/></g></svg>';
  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function renderCart(cart) {
    if (cartCount) {
      if (cart.item_count > 0) { cartCount.style.display = 'flex'; cartCount.textContent = cart.item_count; }
      else { cartCount.style.display = 'none'; }
    }
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your cart is empty.</p></div>';
      if (drawerFoot) drawerFoot.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="citem" data-key="' + item.key + '">' +
        (item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') + '" alt="' + item.product_title + '" width="80" height="80">' : '') +
        '<div><h4>' + item.product_title + '</h4>' +
        (item.variant_title ? '<div class="cv">' + item.variant_title + '</div>' : '') +
        '<div class="cp">' + DH + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cq" data-key="' + item.key + '"><button class="cq-dec" aria-label="Decrease">–</button><span>' + item.quantity + '</span><button class="cq-inc" aria-label="Increase">+</button></div>' +
        '</div></div>';
    });
    drawerBody.innerHTML = html;
    if (drawerFoot) drawerFoot.style.display = 'block';
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  /* drawer qty +/- (delegated) */
  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var wrap = e.target.closest('.cq');
      if (!wrap) return;
      var key = wrap.getAttribute('data-key');
      var span = wrap.querySelector('span');
      var qty = parseInt(span ? span.textContent : '1', 10) || 1;
      if (e.target.classList.contains('cq-inc')) changeLine(key, qty + 1);
      else if (e.target.classList.contains('cq-dec')) changeLine(key, Math.max(0, qty - 1));
    });
  }

  /* add to cart via product form */
  var productForm = $('#productForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[type="submit"]');
      if (btn) btn.classList.add('loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(productForm)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('loading');
          if (!res.ok) { showToast(res.data.description || 'Could not add to cart'); return; }
          return fetchCart().then(function (cart) { renderCart(cart); openCart(); showToast('Added to cart'); });
        })
        .catch(function () { if (btn) btn.classList.remove('loading'); showToast('Could not add to cart'); });
    });
  }

  /* demo add-to-cart (no product connected) */
  var addDemo = $('#addCartDemo');
  if (addDemo) addDemo.onclick = function () { showToast('Connect a product in the theme editor to enable checkout'); };

  /* floating buy → triggers add to cart */
  var fAdd = $('#floatingAdd');
  if (fAdd) fAdd.onclick = function () { var a = $('#addCart') || $('#addCartDemo'); if (a) a.click(); };

  /* language notice */
  var langBtn = $('#langBtn');
  if (langBtn) langBtn.onclick = function () { showToast('Arabic (عربى) version coming soon'); };

  /* keep drawer/count fresh on load */
  if (drawer) fetchCart().then(renderCart).catch(function () {});

  /* esc closes drawer */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- motion layer ---------- */
  var loader = $('#motionLoader');
  function enterSite() { document.body.classList.add('loaded'); if (loader) loader.classList.add('leave'); }
  if (document.readyState === 'complete') setTimeout(enterSite, 400);
  else window.addEventListener('load', function () { setTimeout(enterSite, 500); });
  setTimeout(enterSite, 2200);

  var progress = $('.scroll-progress'), floatBuy = $('#floatingBuy');
  var parallaxEls = $$('[data-parallax]');
  var scrollTick = false;
  function renderParallax() {
    var d = document.documentElement, max = d.scrollHeight - window.innerHeight, p = max ? window.scrollY / max : 0;
    if (progress) progress.style.width = (p * 100) + '%';
    if (floatBuy) floatBuy.classList.toggle('show', window.scrollY > window.innerHeight * 0.7 && window.scrollY < d.scrollHeight - window.innerHeight * 1.3);
    if (!reduce) {
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect(), speed = parseFloat(el.dataset.parallax || 0.05), limit = parseFloat(el.dataset.parallaxLimit || 120);
        var v = (window.innerHeight / 2 - (r.top + r.height / 2)) * speed;
        v = Math.max(-limit, Math.min(limit, v));
        el.style.setProperty('--parallax-y', v.toFixed(2) + 'px');
      });
      var hero = $('.hero');
      if (hero) {
        var hr = hero.getBoundingClientRect(), hp = Math.max(-1, Math.min(1, -hr.top / Math.max(1, hr.height)));
        hero.style.setProperty('--depth-1', (hp * 48).toFixed(1) + 'px');
        hero.style.setProperty('--depth-2', (hp * -86).toFixed(1) + 'px');
        hero.style.setProperty('--depth-3', (hp * 120).toFixed(1) + 'px');
      }
    }
    scrollTick = false;
  }
  function onScrollP() { if (!scrollTick) { scrollTick = true; requestAnimationFrame(renderParallax); } }
  window.addEventListener('scroll', onScrollP, { passive: true });
  window.addEventListener('resize', onScrollP, { passive: true });
  renderParallax();

  /* cursor + magnetic buttons (fine pointer only) */
  if (!reduce && window.matchMedia('(pointer:fine)').matches) {
    var dot = $('.cursor-dot'), ring = $('.cursor-ring');
    if (dot && ring) {
      var x = window.innerWidth / 2, y = window.innerHeight / 2, rx = x, ry = y;
      window.addEventListener('mousemove', function (e) {
        x = e.clientX; y = e.clientY; dot.style.transform = 'translate(' + x + 'px,' + y + 'px)';
        document.documentElement.style.setProperty('--mx', x + 'px');
        document.documentElement.style.setProperty('--my', y + 'px');
      });
      (function loop() { rx += (x - rx) * 0.16; ry += (y - ry) * 0.16; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)'; requestAnimationFrame(loop); })();
      $$('a,button,.thumb,.icard,.tcard').forEach(function (el) {
        el.addEventListener('mouseenter', function () { ring.classList.add('active'); });
        el.addEventListener('mouseleave', function () { ring.classList.remove('active'); });
      });
    }
    $$('.btn').forEach(function (el) {
      el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(); el.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.12 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.18 + 'px)'; });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
    var frame = $('.hero-media .frame');
    if (frame) {
      frame.addEventListener('mousemove', function (e) { var r = frame.getBoundingClientRect(), dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5; frame.style.transform = 'perspective(900px) rotateY(' + dx * 8 + 'deg) rotateX(' + (-dy * 8) + 'deg) translateZ(8px)'; });
      frame.addEventListener('mouseleave', function () { frame.style.transform = ''; });
    }
    $$('.icard,.tcard').forEach(function (c) {
      c.addEventListener('mousemove', function (e) { var r = c.getBoundingClientRect(); c.style.setProperty('--card-x', ((e.clientX - r.left) / r.width * 100) + '%'); c.style.setProperty('--card-y', ((e.clientY - r.top) / r.height * 100) + '%'); });
    });
  }

  /* split section titles into words for stagger-in */
  $$('.stitle').forEach(function (h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) {
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (w) {
          if (!w.trim()) frag.appendChild(document.createTextNode(w));
          else { var sp = document.createElement('span'); sp.className = 'word'; sp.textContent = w; frag.appendChild(sp); }
        });
        n.parentNode.replaceChild(frag, n);
      }
    });
  });
  if ('IntersectionObserver' in window) {
    var wordObs = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('words-in'); }); }, { threshold: 0.35 });
    $$('.stitle').forEach(function (e) { wordObs.observe(e); });
  } else {
    $$('.stitle').forEach(function (e) { e.classList.add('words-in'); });
  }

  /* register decorative sprigs + media as parallax targets */
  $$('.hero .sprig,.science .sprig,.story .sprig,.ctaband .sprig,.ing .sprig,.page-header .sprig').forEach(function (e, i) {
    e.dataset.parallax = (i % 2 ? -0.055 : 0.065); e.dataset.parallaxLimit = '95'; parallaxEls.push(e);
  });

  /* reveal direction + stagger */
  $$('.reveal').forEach(function (e, i) {
    if (!e.dataset.reveal) e.dataset.reveal = i % 3 === 0 ? 'left' : i % 3 === 1 ? 'right' : 'up';
    e.style.transitionDelay = ((i % 4) * 70) + 'ms';
  });

  /* animated stat counters */
  if ('IntersectionObserver' in window) {
    var statObs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || e.target.dataset.done) return;
        e.target.dataset.done = '1';
        var raw = e.target.textContent, match = raw.match(/[\d.]+/);
        if (!match) return;
        var end = parseFloat(match[0]), suffix = raw.replace(match[0], ''), t0 = performance.now();
        (function tick(t) {
          var p = Math.min(1, (t - t0) / 1200), v = end * (1 - Math.pow(1 - p, 3));
          e.target.textContent = (end % 1 ? v.toFixed(1) : Math.round(v)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }, { threshold: 0.6 });
    $$('.sci-stat .n,.hero-badge .n').forEach(function (e) { statObs.observe(e); });
  }

  /* safety: force-reveal anything still hidden after load */
  setTimeout(function () {
    $$('.reveal').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.15) el.classList.add('in'); });
  }, 1800);
  window.addEventListener('error', function () {
    document.body.style.cursor = 'auto';
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
    if (loader) loader.style.display = 'none';
  });
})();
